<template>
  <div style="text-align: center; margin: 100px;">

    <el-row>
      <el-col span="6" offset="9">
        <el-form label-width="100px" style="width: 400px;" :model="regist" :rules="rules" ref="ruleForm">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="regist.username" type="text" placeholder="" style="width: 300px">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="regist.password" type="password" placeholder="" style="width: 300px"> </el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="passwordConfirm">
            <el-input v-model="regist.passwordConfirm" type="password" placeholder="" style="width: 300px">
            </el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="regist.companyName" type="text" placeholder="" style="width: 300px"> </el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="phone">
            <el-input v-model="regist.phone" type="text" placeholder="" style="width: 300px"> </el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="email">
            <el-input v-model="regist.email" type="text" placeholder="" style="width: 300px"> </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width: 120px" @click="registAccount('ruleForm')">注册</el-button>
            <el-button type="danger" style="width: 120px" @click="back">返回</el-button>
          </el-form-item>
        </el-form>
      </el-col>

    </el-row>

  </div>
</template>

<script>
  import axios from '@/axios'
  import {
    mapState
  } from 'vuex'
  export default {
    data() {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.regist.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        regist: {
          username: '',
          password: '',
          passwordConfirm: '',
          companyName: '',
          phone: '',
          email: '',
        },
        rules: {
          username: [{
              required: true,
              message: '请输入用户名',
              trigger: 'blur'
            },
            {
              min: 5,
              max: 16,
              message: '长度在 5 到 16 个字符',
              trigger: 'blur'
            }
          ],
          password: [{
              validator: validatePass,
              trigger: 'blur'
            },
            {
              min: 5,
              max: 16,
              message: '长度在 5 到 16 个字符',
              trigger: 'blur'
            },
            {
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            },
          ],
          passwordConfirm: [{
              validator: validatePass2,
              trigger: 'blur'
            },
            {
              min: 5,
              max: 16,
              message: '长度在 5 到 16 个字符',
              trigger: 'blur'
            },
            {
              required: true,
              message: '请输入验证密码',
              trigger: 'blur'
            },
          ],
          companyName: [{
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          }],
          phone: [{
            min: 11,
            max: 11,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }],
          email: [],
        }

      }
    },
    methods: {

      registAccount(ruleForm) {

        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在注册，请稍后……',
              spinner: 'el-icon-loading',
              background: 'rgba(255, 255, 255, 0.7)'
            });

            var json = JSON.stringify(this.regist)
            var url = 'framework/SysLogin/regist.do'
            var param = {
              json: json
            }
            axios.post(url, param).then(response => {
              
 
                loading.close();
                
                this.$store.commit('setMenuLoaded', false)
                this.$store.commit('setRouteLoaded', false)
                localStorage.setItem('userId', response.data.data.id)
                localStorage.setItem('userCode', response.data.data.userCode)
                localStorage.setItem('userName', response.data.data.userName)
                localStorage.setItem('token', response.data.data.token)
                localStorage.setItem('belongId', response.data.data.belongId)
                this.$router.push('/home/main')
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },
      back() {
        this.$router.push('/login')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/framework/login/regist.vue